const STATUS_LABELS = {
  open: "Aberta",
  locked: "Travada",
  closed: "Fechada",
};

const STATUS_PILLS = {
  open: "success",
  locked: "attention",
  closed: "none",
};

// Sprint sem encerramento vai para o fim, em vez de comparar contra NaN e
// cair numa ordem indefinida.
export function sortByDueDateDesc(sprints) {
  return [...(sprints || [])].sort((a, b) => {
    if (!a.due_date && !b.due_date) return 0;
    if (!a.due_date) return 1;
    if (!b.due_date) return -1;
    return new Date(b.due_date) - new Date(a.due_date);
  });
}

export function sprintStatusLabel(status) {
  if (!status) return null;
  return STATUS_LABELS[status] || status;
}

export function sprintStatusPill(status) {
  return STATUS_PILLS[status] || "none";
}
